module.exports = __webpack_public_path__ + "static/media/pm_bg_how_it_works.7c0b51b8.svg";